const hasScroll = () => document.querySelector("#quiz-container")?.clientHeight < document.querySelector("#quiz-container")?.scrollHeight;
export default hasScroll;
